import React from "react";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "antd/dist/antd.css";
import "./index.css";
import "./custom.less";
import CurrentShopIdProvider from "./provider/currentShopIdProvider";
import CurrentLoginTypeProvider from "./provider/currentLoginTypeProvider";
import * as ReactDOMClient from "react-dom/client";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import rootReducer from "./redux/rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import { createStore } from "redux";
import { PersistGate } from "redux-persist/integration/react";

const persistConfig = {
  key: "root",
  storage, // only products will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let store = createStore(persistedReducer);

const container = document.getElementById("root");
let persistor = persistStore(store);
const root = ReactDOMClient.createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <CurrentShopIdProvider>
          <CurrentLoginTypeProvider>
            <App />
          </CurrentLoginTypeProvider>
        </CurrentShopIdProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
